import React from "react";
import Navigation from "../components/Navigation";
import bannerimg2 from "./../mysy_img/MYSY-LOGO-BLUE.png";
import { Helmet } from "react-helmet";
import Footer from "../components/Fotter";
import Header from "../components/Header";


const NotFound = () => {
  return (
    <div className="notfound">
      <div>
        <Navigation />
      </div>
      <Helmet>
        <title>Page introuvable</title>
        <meta name="description" content="Nous sommes une base de données uniquement dediée aux formations et tutoriels" />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="title" content="Trouver des Formations.Acces libre.Qualité top" />
        <link rel="canonical" href={window.location.href}/>

      </Helmet>
      <Header />

 
      <div className="div_mobile">
        <br/>
        <br/>
        <div className="nom_prenom"> Cette formation n'est pas active ou n'existe pas.</div>
        <div className="nom_prenom"> <a href={process.env.REACT_APP_BASE_URL}> Retour vers le moteur de recherche </a> </div>
      </div>
      <div className="pieddepage">
        <Footer />
      </div>


    </div>
  )
}

export default NotFound;